import Bugsnag from '@bugsnag/js';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';

const BUGSNAG_API_KEY = 'b8de5357ec7953594571224f6a8ee5d5';
const bugsnagEnabled = !!(
  window.__CONFIG__.webMonitoringEnabled && window.__CONFIG__.trackJsAppName
);
const experimentLoggingEnabled = event => {
  if (event && event._metadata && event._metadata.metaData) {
    const experiments = event._metadata.metaData;
    if (experiments[11356] || experiments[11637] || experiments[11947]) {
      return true;
    }
  }
  return false;
};

export const ERROR_TYPE_API = 'api';
export const ERROR_TYPE_UI = 'ui';

Bugsnag.start({
  apiKey: BUGSNAG_API_KEY,
  appVersion: __VERSION__,
  releaseStage: __RELEASE_STAGE__,
  autoTrackSessions: false,
  onError: (event, callback) => {
    // do not send bugs related to mraid.js
    if (
      event.errors.some(error => error.stacktrace.some(trace => trace.file.endsWith('mraid.js')))
    ) {
      return callback(null, false);
    }

    if (bugsnagEnabled || experimentLoggingEnabled(event)) {
      return callback(null);
    }
    return callback(null, false);
  },
  plugins: [new BugsnagPluginReact()],
  metadata: {},
});

export const BugsnagErrorBoundary = Bugsnag.getPlugin('react').createErrorBoundary(React);
